import  { lazy, Suspense } from "react";
import type { ReactNode } from "react";
import DialogHeader from "./footer/DialogHeader";

interface DialogNoFooterProps {
  open: boolean;
  close: () => void;
  children: ReactNode;
  title: string;
  subtitle: string;
}

const DialogOnlyWrapper = lazy(() => import("./DialogOnlyWrapper"));

const DialogNoFooter: React.FC<DialogNoFooterProps> = ({
  open,
  close,
  children,
  title,
  subtitle,
}) => {
  if (!open) return null;

  return (
    <Suspense fallback={<div />}>
      <DialogOnlyWrapper>
        <div className="gx-dialog-box">
          <DialogHeader handleClose={close} title={title} subtitle={subtitle} />
          <div className="gx-dialog-main dialogno-footer-main">{children}</div>
        </div>
      </DialogOnlyWrapper>
    </Suspense>
  );
};

export default DialogNoFooter;
